import React, { useState } from "react";
import axios from "axios";
import {
  Dialog,
  DialogContent,
  Button,
  TextField,
  Typography,
  IconButton,
  Box,
  Stack,
  InputAdornment,
  Alert,
  Fade,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import LocationOnIcon from "@mui/icons-material/LocationOn";

export default function ModalUbicacion({ empresaId, actualizarTabla }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [open, setOpen] = useState(false);
  const [lugar, setLugar] = useState("");
  const [epc, setEpc] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const API_GUARDAR = "https://demo.datachile.site/API/web/guardar_lugar.php";

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setLugar("");
    setEpc("");
    setError("");
  };

  const guardarUbicacion = async (e) => {
  e.preventDefault();
  if (!lugar) return setError("Debe ingresar la ubicación"); // Solo validar lugar, EPC opcional

  try {
    setLoading(true);
    await axios.post(API_GUARDAR, { lugar, epc, empresa_idempresa: empresaId });
    actualizarTabla();
    handleClose();
  } catch (err) {
    console.error(err);
    setError("Error al guardar ubicación");
  } finally {
    setLoading(false);
  }
};

  return (
    <>
      <Button
        variant="contained"
        onClick={handleOpen}
        sx={{
          borderRadius: 2,
          px: 3,
          background: "linear-gradient(90deg, #1976d2, #42a5f5)",
        }}
      >
        Agregar Ubicación
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="sm"
        fullScreen={isMobile}
        TransitionComponent={Fade}
        PaperProps={{ sx: { borderRadius: isMobile ? 0 : 4, display: "flex", flexDirection: "column" } }}
      >
        {/* HEADER */}
        <Box
          sx={{
            px: 4,
            py: 3,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            background: "linear-gradient(90deg, #1976d2, #42a5f5)",
            color: "white",
          }}
        >
          <Typography variant="h6">Nueva Ubicación</Typography>
          <IconButton onClick={handleClose} sx={{ color: "white" }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <form onSubmit={guardarUbicacion}>
          <DialogContent dividers sx={{ p: 4, overflowY: "auto" }}>
            {error && <Alert severity="error">{error}</Alert>}

            <Stack spacing={3}>
              <TextField
                label="Ubicación"
                fullWidth
                value={lugar}
                onChange={(e) => setLugar(e.target.value)}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LocationOnIcon />
                    </InputAdornment>
                  ),
                }}
              />
              <TextField
                label="EPC"
                fullWidth
                value={epc}
                onChange={(e) => setEpc(e.target.value)}
              />
            </Stack>

            <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
              <Button onClick={handleClose} variant="outlined" fullWidth={isMobile}>
                Cancelar
              </Button>
              <Button
                type="submit"
                variant="contained"
                fullWidth={isMobile}
                disabled={loading}
                sx={{ background: "linear-gradient(90deg, #1976d2, #42a5f5)" }}
              >
                {loading ? "Guardando..." : "Guardar"}
              </Button>
            </Box>
          </DialogContent>
        </form>
      </Dialog>
    </>
  );
}